export const takeOutBlankSpace = (string) => {
  const regex = /\s/g;
  const replace = '';
  string = string.replace(regex, replace);
  return string;
};